import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { NotificationManager } from 'react-notifications';
import classnames from 'classnames';
import moment from "moment";
import { Link } from 'react-router-dom';
import { Loader } from "../../components/loader";
import { BreadCrumb } from '../../components/breadcrumb';
import { fetchPetQueueRecords, retryFetchContract } from '../../actions/wooStore';
const $ = window.$;

const contactCreationStatusOptions = {
    0: 'In-Progress',
    1: 'Already-Exists',
    2: 'No-Woo-Order',
    3: 'Created',
    4: 'Failed'
}

const welcomeEmailStatusOptions = {
    0: 'None',
    1: 'Waiting-To-Send',
    2: 'In-Progress',
    3: 'Sent',
    4: 'Failed'
}

const jobStatusOptions = {
    0: 'Waiting',
    1: 'In-Progress',
    2: 'Completed',
    3: 'Failed'
}

var tableHeaderColumnData = [];
const { SearchBar } = Search;

class WooStore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            contentData: [],
            cdInProgress: [],
            cdWaiting: [],
            cdFailed: [],
            cdCompleted: [],
            selectedTab: 'All',
        };
    }

    tableHeaderColumnData = [
        {
            dataField: 'customer_name', text: 'Customer', sort: true
        },
        {
            dataField: 'pet_id', text: 'Pet ID', sort: true, formatter: (cell, row) => {
                return (
                  <span className="m-topbar__userpic">
                    <img src={process.env.REACT_APP_S3_PATH + '/' + row.avatar_path + '/' + row.avatar_file_name} className="m--img-rounded m-width-50 mr-2" alt="" />
                    <span className="m-badge m-badge--info mx-auto my-0 px-2"><strong>{cell}</strong></span>
                  </span>
                )
            }
        },

        {
            dataField: 'contract_creation_status', text: 'Contract Creation Status', sort: true, formatter: (cell, row) => {
                return (
                    <span className={"m-badge mx-auto my-0 px-2 " + ((cell === 'None') ? 'm-badge--metal' : (cell === 'In-Progress') ? 'm-badge--warning' : (cell === 'Created' || cell === 'Already-Exists' || cell === 'No-Woo-Order') ?  'm-badge--success' : (cell === 'Failed') ? ' m-badge--danger' : ' m-badge--metal')}><strong>{cell}</strong></span>
                )
              },
              filterValue: (cell, row) => {
                for(let t in contactCreationStatusOptions){
                  if(contactCreationStatusOptions[t]===cell){
                    return t;
                  }
                }
              }
        },
        {
            dataField: 'welcome_email_status', text: 'Welcome Email Status', sort: true, formatter: (cell, row) => {
                return (
                    <span className={"m-badge mx-auto my-0 px-2 " + ((cell === 'None') ? 'm-badge--metal' : (cell === 'Waiting-To-Send') ? 'm-badge--wide' : (cell === 'In-Progress') ? 'm-badge--warning' : (cell === 'Sent') ?  'm-badge--success' : (cell === 'Failed') ? 'm-badge--danger' : ' m-badge--metal')}><strong>{cell}</strong></span>
                )
              },
              filterValue: (cell, row) => {
                for(let t in welcomeEmailStatusOptions){
                  if(welcomeEmailStatusOptions[t]===cell){
                    return t;
                  }
                }
              }
        },
        {
            dataField: 'job_status', text: 'Status', sort: true, formatter: (cell, row) => {
                return (
                    <span className={"m-badge mx-auto my-0 px-2 " + ((cell === 'Waiting') ? 'm-badge--wide' : (cell === 'In-Progress') ? 'm-badge--warning' : (cell === 'Completed') ?  'm-badge--success' : (cell === 'Failed') ? 'm-badge--danger' : ' m-badge--metal')}><strong>{cell}</strong></span>
                )
              },
              filterValue: (cell, row) => {
                for(let t in jobStatusOptions){
                  if(jobStatusOptions[t]===cell){
                    return t;
                  }
                }
              }
        },
        {
            dataField: 'updatedAt', text: 'Last Updated', formatter: cell => moment(cell).format("MM-DD-YYYY, hh:mm A"), sort: true
        },
        {
            dataField: 'more_information', text: 'More Information', sort: true
        },
        {
            dataField: 'actions', text: 'Actions', formatter: this.buttonFormatter.bind(this)
        },
    ];
    
    buttonFormatter(cell, row) {
        return (
            <div>
                <a className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="Retry" onClick={(e) => {
                  this.retryFetchContractItem(e, row)
                }}>
                    <i className="fa fa-retweet"></i>
                </a>
            </div>
            
        );
    }
    
    componentDidMount() {
        this.props.fetchPetQueueRecords();
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.data.wooStoreReducer.petQueueRecords != nextProps.data.wooStoreReducer.petQueueRecords) {
            let cdWaiting = nextProps.data.wooStoreReducer.petQueueRecords.filter(m => m.job_status==='Waiting');
            let cdInProgress = nextProps.data.wooStoreReducer.petQueueRecords.filter(m => m.job_status==='In-Progress');
            let cdFailed = nextProps.data.wooStoreReducer.petQueueRecords.filter(m => m.job_status==='Failed');
            let cdCompleted = nextProps.data.wooStoreReducer.petQueueRecords.filter(m => m.job_status==='Completed');
            
            this.setState({ contentData: nextProps.data.wooStoreReducer.petQueueRecords, cdWaiting: cdWaiting, cdInProgress: cdInProgress, cdFailed: cdFailed, cdCompleted: cdCompleted, loading : false });
            NotificationManager.success(`Task Manager queue data refreshed successfully`);
        }

        if (nextProps.data.wooStoreReducer.retryFetchContractResult != null 
            && this.props.data.wooStoreReducer.retryFetchContractResult != nextProps.data.wooStoreReducer.retryFetchContractResult) {
            const SuccessCode = 200;
            const RestrictedRetryCode = 300;

            if (nextProps.data.wooStoreReducer.retryFetchContractResult) {
                if (nextProps.data.wooStoreReducer.retryFetchContractResult.StatusCode === SuccessCode) {
                    NotificationManager.success(`Selected Task Manager queue item is now in [Waiting] status.`);
                    this.props.fetchPetQueueRecords();
                }
                else if (nextProps.data.wooStoreReducer.retryFetchContractResult.StatusCode === RestrictedRetryCode) {
                    NotificationManager.warning(`Selected Task Manager queue item is in a restricted retry state.`);
                }
                else {
                    NotificationManager.error(`There was a problem in resetting the selected Task Manager queue item.`);
                }
            }
            else {
                NotificationManager.error(`There was a problem in resetting the selected Task Manager queue item.`);
            }
        }
    }

    refreshQueue = () => {
        this.props.fetchPetQueueRecords();
    }

    retryFetchContractItem = (e, row) => {
        e.preventDefault();

        if (row && row.id) {
            this.props.retryFetchContract(row.id);
        }
    }

    items = [
        {title: 'Task Manager', to: '/woo-store'}
    ]

    render() {
        const { contentData, cdInProgress, cdWaiting, cdFailed, cdCompleted } = this.state;

        return (
            <div className="m-grid m-grid--hor m-grid--root m-page">
                <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                    <BreadCrumb items={this.items}/>
                    <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver m-container m-container--responsive m-container--xxl m-page__container">
                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="m-portlet m-portlet--mobile">
                                <div className="m-portlet__head medical-record-head-btn-set">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text">Task Manager                       
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="medical-record-button-container">
                                        <div className="m-portlet__head-tools breed-delivery-record-btn" />
                                        <div className="m-portlet__head-tools breed-delivery-record-btn" />
                                        <div className="m-portlet__head-tools breed-delivery-record-btn" />
                                        <div className="m-portlet__head-tools breed-delivery-record-btn" />
                                        <div className="m-portlet__head-tools breed-delivery-record-btn">
                                            <Link to='/video-manager' className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                                <span>
                                                    <i className="la la-video"></i>
                                                    <span>Video Manager</span>
                                                </span>
                                            </Link>
                                        </div>
                                        <div className="m-portlet__head-tools breed-delivery-record-btn">
                                            <a href="#" className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" onClick={this.refreshQueue}>
                                                <span><i className="la la-refresh"></i><span>Refresh</span></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <ul className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn" role="tablist">
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'All'})} onClick={() => this.setState({ selectedTab: 'All' })}>All</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'In-Progress'})} onClick={() => this.setState({ selectedTab: 'In-Progress' })}>In Progress</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Waiting'})} onClick={() => this.setState({ selectedTab: 'Waiting' })}>Waiting</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Failed'})} onClick={() => this.setState({ selectedTab: 'Failed' })}>Failed</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Completed'})} onClick={() => this.setState({ selectedTab: 'Completed' })}>Completed</button>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                                        { !this.state.loading ?
                                            <ToolkitProvider

                                                keyField="id"
                                                data={this.state.selectedTab === 'All' ? contentData : this.state.selectedTab === 'In-Progress' ? cdInProgress : this.state.selectedTab === 'Waiting' ? cdWaiting : this.state.selectedTab === 'Failed' ? cdFailed : this.state.selectedTab === 'Completed' ? cdCompleted : {}} 
                                                columns={this.tableHeaderColumnData}
                                                search
                                                defaultSortDirection="asc"
                                                hover={true}
                                                
                                                filter={filterFactory()}
                                            >
                                                {
                                                    props => (
                                                        <div>
                                                            <div className='px-0 mb-4 search-bar'>
                                                                <div className='col-lg-3 px-0 inner-addon right-addon'>
                                                                <i className="fas fa-search"></i>
                                                                <SearchBar {...props.searchProps} />
                                                                </div>
                                                                </div>
                                                            <BootstrapTable
                                                                classes="petVerticalCenterTable"
                                                                {...props.baseProps}
                                                                pagination={paginationFactory()}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider>:
                                            <div className="center-row">
                                               <Loader size={50}/>
                                             </div>
                                        }
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  data: state
});

const mapDispatchToProps = dispatch => ({
  
    fetchPetQueueRecords: () => {
        dispatch(fetchPetQueueRecords());
    },

    retryFetchContract: id => {
        dispatch(retryFetchContract(id));
    }

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WooStore));
